import React from 'react';
import styled from 'styled-components';

import { Icons, Typography } from 'components';
import { IconsTypes } from 'components/icons';
import { DownloadTypeEnum } from 'features/downloads';
import { saveAs } from 'file-saver';
import { useSchool } from 'features/school';
import { request } from 'app/utils';
import { AxiosResponse } from 'axios';

const ButtonIcon = styled(Icons)`
  color: ${({ theme }) => theme.colors.primary_400};

  ${({ theme: { mediaQueries } }) => {
    return `
      width: 20px;

      ${mediaQueries.desktop} {
        width: 26px;
      }
    `;
  }}
`;

const ButtonLabel = styled(Typography)``;

const ButtonWrapper = styled('a')`
  border: 1px solid;
  border-color: #dce0de;
  text-align: left;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 10px;
  width: 100%;

  &:hover {
    background: ${({ theme }) => theme.colors.primary_400};

    ${ButtonLabel},
    ${ButtonIcon} {
      color: white;
    }
  }

  &:active {
    background: ${({ theme }) => theme.colors.primary_600};

    ${ButtonLabel},
    ${ButtonIcon} {
      color: white;
    }
  }

  ${({ theme: { mediaQueries } }) => {
    return `
      padding: 15px;

      ${mediaQueries.desktop} {
        padding: 20px;
      }
    `;
  }}
`;

interface EventButtonDownloadProps {
  filePath: string;
  icon?: IconsTypes;
  name: string;
  type?: DownloadTypeEnum;
  fileName?: string;
}

const EventButtonDownload = ({ filePath, icon = 'download', name, type = 0, fileName = '' }: EventButtonDownloadProps) => {
  const { apiGatewayUrl } = useSchool();
  const getDownload = (downloadUrl: string, downloadFileName: string) => {
    request({
      url: downloadUrl,
      method: 'get',
      baseURL: apiGatewayUrl,
      responseType: 'blob',
      onDownloadProgress: () => {},
    })
      .then((response: AxiosResponse<Blob>) => {
        saveAs(response.data, downloadFileName);
      })
      .catch((error) => {});
  };
  return (
    <>
      {type === 0 && (
        <ButtonWrapper href={filePath} type="external" target="_blank">
          <ButtonIcon icon={icon} />
          <ButtonLabel type="type2" fontWeight="bold" ml={2}>
            {name}
          </ButtonLabel>
        </ButtonWrapper>
      )}

      {(type === 1 || type === 2) && (
        <ButtonWrapper onClick={() => getDownload(filePath, fileName)}>
          <ButtonIcon icon={icon} />
          <ButtonLabel type="type2" fontWeight="bold" ml={2}>
            {name}
          </ButtonLabel>
        </ButtonWrapper>
      )}
    </>
  );
};

export default EventButtonDownload;
